module.exports = __webpack_public_path__ + "media/packs/images/flags/IR-2e5f822ae1c380f6a5cdbe0df4293256.svg";